<!-- 物流详情 -->
<template>
  <img @click="openMini" class="mibiBox"
       src="https://iqh-zt-pord-cdn.iqihang.com/ark-student-wap/businessOrder/linkMiniImg.png"/>
</template>
<script>

import {urlScheme} from '@/api/businessOrder';

export default {
  data() {
    return {};
  },
  props: {},
  watch: {},
  components: {},

  computed: {},

  mounted() {
  },

  created() {
  },

  methods: {
    async openMini() {
      const params = {
        appid: "wxdb89cfa2bb60f779",
        envVersion: "release", // trial  release
        path: 'pages/home/home',
        query: 'channel=dsckd'
      };
      const {code, data} = await urlScheme(params);
      if (code === 0) {
        window.location.href = data
      }
    }
  },
};
</script>
<style lang="scss" scoped>
.mibiBox {
  width: 100%;
  position: fixed;
  left: 0;
  bottom: 0;
}
</style>
